import { derived } from 'svelte/store';
import { configStore } from '#stores/configs/config.js';

export const userStore = derived([configStore], ([$configStore]) => {
    return $configStore.user;
});
